var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "43px",
    viewBox: "0 0 75 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new",
    transform: "translate(0.000000, -0.000000)",
    fill: "#5E5F5F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.524590, 14.293033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.29533811,14.7740779 L0.0699282787,14.7740779 L0.0699282787,0.396516393 L2.29533811,0.396516393 L2.29533811,2.26460041 C3.21285861,1.19800205 4.90266393,0.0391905738 7.15727459,0.0391905738 C10.2371926,0.0391905738 11.8401639,1.99487705 11.8401639,5.20005123 L11.8401639,14.7740779 L9.6147541,14.7740779 L9.6147541,5.73104508 C9.6147541,2.73796107 7.78048156,2.17315574 6.32658811,2.17315574 C4.66598361,2.17315574 3.03381148,3.21132172 2.29533811,4.48539959 L2.29533811,14.7740779 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3696209,7.59989754 C15.3696209,3.1821209 17.9185451,0.0391905738 21.7423156,0.0391905738 C26.1016906,0.0391905738 27.6708504,4.07044057 27.6708504,7.5414959 L27.6708504,8.16393443 L17.6196209,8.16393443 C17.8563012,11.1570184 19.8165984,13.1127049 22.8965164,13.1127049 C24.4702869,13.1127049 25.6867316,12.6977459 26.7540984,11.9877049 L26.7540984,13.9433914 C25.8027664,14.6534324 24.2920082,15.1314037 22.3947234,15.1314037 C18.3627049,15.1314037 15.3696209,12.1959529 15.3696209,7.59989754 Z M25.4162398,6.38268443 C25.4162398,4.57684426 24.4410861,2.0571209 21.6839139,2.0571209 C19.2502561,2.0571209 17.7971311,4.13345287 17.6480533,6.38268443 L25.4162398,6.38268443 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "43.5745389 11.423668 46.8335041 0.396516393 49.1173156 0.396516393 44.6419057 14.8947234 42.6577869 14.8947234 39.3650102 3.83376025 36.0722336 14.8947234 34.145748 14.8947234 29.6995389 0.396516393 31.9541496 0.396516393 35.2423156 11.423668 38.4766906 0.396516393 40.3109631 0.396516393"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5023053,42.6869877 C16.8242828,42.6869877 0.00384221311,33.1229508 0.00384221311,21.3642418 C0.00384221311,9.60553279 16.8242828,0.0384221311 37.5023053,0.0384221311 C58.1757172,0.0384221311 74.9961578,9.60476434 74.9961578,21.3634734 C74.9961578,33.1221824 58.1757172,42.6869877 37.5023053,42.6869877 Z M37.5023053,1.27484631 C17.505123,1.27484631 1.23949795,10.286373 1.23949795,21.3642418 C1.23949795,32.4398053 17.505123,41.451332 37.5023053,41.451332 C57.494877,41.451332 73.760502,32.4398053 73.760502,21.3642418 C73.760502,10.286373 57.494877,1.27484631 37.5023053,1.27484631 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.95bd37c41760bd556080c873cfdbb739.svg";
export { ForwardRef as ReactComponent };